import type { QueriesObject, QueryResults, System } from '../../odie';

import { BeeScatteringEffect } from '../actions/effects/BeeScatteringEffect';
import { SmokeEffect } from '../actions/effects/SmokeEffect';
import { NestBlockComponent } from '../components/NestBlockComponent';
import { GameEvent } from '../defs/event';
import { despawnBlockEntity, NestBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';
import { getMatch2AssetPath } from '../util/assets';

/*
    handles bee nest block specifics
*/
export class NestBlockSystem implements System {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockNest';
  public static Queries: QueriesObject = {
    nest: {
      components: [NestBlockComponent],
    },
  };

  // fields
  //-------------------------------------------------------------------------
  // injected
  public scene!: GameScene;
  public queries!: QueryResults;
  // handlers
  private _gameEventHandler: any = (event: GameEvent) =>
    this._onGameEvent(event);

  // impl
  //-------------------------------------------------------------------------
  public awake() {
    // notify
    this.scene.events.subscribe(this._gameEventHandler);
  }

  public reset() {
    // notify
    this.scene.events.unsubscribe(this._gameEventHandler);
  }

  // private: events
  //-------------------------------------------------------------------------
  private _onGameEvent(event: GameEvent) {
    // on bee goal complete, clear all remaining nests
    if (event.id === 'goal' && event.goalId === 'nest' && event.count === 0) {
      const nests: NestBlockEntity[] = [];
      this.queries.nest.forEach((entity: NestBlockEntity) =>
        nests.push(entity),
      );
      nests.forEach((entity) => void this._clearNest(entity));
    }
  }

  private async _clearNest(entity: NestBlockEntity) {
    const position = entity.c.position.mapPosition;

    // despawn on complete
    despawnBlockEntity(this.scene, entity);

    await Promise.all([
      new SmokeEffect(this.scene, { position, tint: 0xfff7d7 }).execute(),
      new BeeScatteringEffect(this.scene, {
        position,
        asset: getMatch2AssetPath('fx.nest/fx.nest.bee.png'),
      }).execute(),
    ]);
  }
}
